module.exports = __webpack_public_path__ + "static/media/no-offers.995be234.svg";